import { FormGroup } from '@angular/forms';
import { MonoTypeOperatorFunction, pipe } from 'rxjs';
import { tap } from 'rxjs/operators';
import { resetFormControls } from '../../utils/form/form.utils';

export function resetControls(
  ...controlKeys: string[]
): MonoTypeOperatorFunction<FormGroup | null | undefined> {
  return pipe(
    tap((form: FormGroup | null | undefined) =>
      resetFormControls(form, ...controlKeys)
    )
  );
}
